import { useI18n } from '../../../i18n';
import styles from './styles.module.scss';

export function Empty() {
  const { i18n } = useI18n();

  return <div className={styles['empty']}>{i18n('emptyPreview')}</div>;
}
